import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.SeatVideoPromo = class SeatVideoPromo extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-seat-video-promo';
	}

	constructor(element) {
		super(element);
	}

	render() {
		this.setVars();
		this.setVideoData();
		this.addVideoEventListeners();
	}

	setVars() {
		this.$videoPlayIcon = this.$element.find('.featured-media__expand--video');
		this.$videoThumbnailLink = this.$element.find('.responsive-image');
		this.$videoThumbnailBlock = this.$element.find('.fa-content-promo__block-link');
		this.$videoLinkBlock = this.$element.find('.video-link__block-link');
	}

	addVideoEventListeners() {
		this.$videoThumbnailLink.on('click', this.onVideoThumbnailClick.bind(this));
		this.$videoThumbnailBlock.on('click', this.onVideoThumbnailClick.bind(this));
		this.$videoLinkBlock.on('click', this.onVideoThumbnailClick.bind(this));
		if (this.$videoPlayIcon) {
			this.$videoPlayIcon.on('click', this.onVideoThumbnailClick.bind(this));
		}
	}

	onVideoThumbnailClick(event) {
		this.$window.trigger('modal:openModal', {
			title: this.videoTitle,
			$view: this.$videoTemplate,
			$prevElement: this.$element
		});

		event.preventDefault();
	}

	formatVideoUrl(url) {
		return url+= '';
	}

	setVideoData() {
		const videoUrl = this.formatVideoUrl(this.$element.data('videoUrl'));

		this.videoTitle = this.$element.data('videoTitle');
		this.$videoTemplate = $(window.videoTemplate({
			videoUrl
		}));
	}
};



// WEBPACK FOOTER //
// ./components/video-seats/scripts/video.js